module.exports = __webpack_public_path__ + "static/media/last_words_icon.bf7a427c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/last_words_icon.png
// module id = 1513
// module chunks = 0